import React from 'react';
import AppointmentRegistration from './AppointmentRegistration';
export default function FluRegistration() {return <AppointmentRegistration project="FLU"/>;}
